import constant from "../Shell/Constant";
import { AuthRequest, GetRequest, PostRequest } from "./Api/Apibase";
import { GetDriverTokenByDevice, SyncApplicationWithServer } from "./Api/RidesServices";
import AppSettings from "./AppSettings";
import { store } from '../Store/store';
import { updateIsLoadingRefreshToken } from "../Store/Slices/tokenSlice";
import { navigate } from "../Shell/Navigation";
import { storageService } from "./Storage/storage.service";
// Basic Reload
var isOnline = window.navigator.onLine
isOnline = true
window.addEventListener('online', async () => {
    isOnline = true;
    await SyncApplicationWithServer();
});
window.addEventListener('offline', () => {
    isOnline = false
});
// Auth Data
const DATA = "USER_DATA";
const Data = "APP_DATA";
const AuthService = {
    isAuthenticated(tagData) {
        let localData = AuthService.getAuthDataByName("token");

        if (!localData) return "empty";

        if (localData === tagData) return "Valid";

        if (tagData.length !== 6) return "notValid";

        return "Different";
    },
    setUserData(key, value) {
        let userData = localStorage.getItem(DATA);
        if (!userData) {
            userData = {};
        } else {
            userData = JSON.parse(userData);
        }
        userData[key] = value;
        localStorage.setItem(DATA, JSON.stringify(userData));
    },
    // remove user data by key
    removeUserData(key) {
        let userData = localStorage.getItem(DATA);
        if (userData) {
            userData = JSON.parse(userData);
            delete userData[key];
            localStorage.setItem(DATA, JSON.stringify(userData));
        }
    },
    setAppData(key, value) {
        let userData = localStorage.getItem(Data);
        if (!userData) {
            userData = {};
        } else {
            userData = JSON.parse(userData);
        }
        userData[key] = value;
        localStorage.setItem(Data, JSON.stringify(userData));
    },
    getUserData() {
        let data = JSON.parse(localStorage.getItem(DATA));
        return data;
    },
    getAppData() {
        let data = JSON.parse(localStorage.getItem(Data));
        return data;
    },
    getAuthDataByName(name) {
        const data = this.getUserData();
        if (data) {
            return data[name] || null
        } else {
            return null;
        }
    },
    getAppDataByName(name) {
        const data = this.getAppData();
        if (data) {
            return data[name] || null
        } else {
            return null;
        }
    },
    signOut() {
        localStorage.removeItem("USER_DATA");
        localStorage.removeItem("APP_DATA");
        localStorage.removeItem("alreadyVisited");
        localStorage.removeItem("centerData", false)
        localStorage.removeItem("tokenUID");
        storageService.clear();

        window.location.href = "/";
    },
};
let ActivateByCode = async (code) => {
    if (code === "736467") {
        let obj = {

            // "data": {
            //     "gsid": 1292,
            //     "tagId": "XAVUS_CHRISCROSSV224",
            //     "deviceSecret": "C637BA23-B95A-47B3-BCC8-467B587359E9",
            // }
            // "data": {
            //     "gsid": 1292,
            //     "tagId": "XAVUS_CHRISCROSSV65",
            //     "deviceSecret": "733C4F4F-5E2B-4680-B35D-9BB6D88F26B9",
            // },
            // "data": {
            //     "gsid": 3061,
            //     "tagId": "XAVUS_THOMASV24",
            //     "deviceSecret": "787A309D-9781-4BD0-894E-1E14CCF2665C",
            // },
            "data": { //using
                "gsid": 1520,
                "tagId": "XAVUS_TUTORV7",
                "deviceSecret": "62C2C66F-C705-468B-B530-7BFBD53AEDEE",
            },
            // "data": { //506982
            //     "gsid": 1531,
            //     "tagId": "XAVUS_TUTORV52",
            //     "deviceSecret": "0C587FA1-650C-4993-9514-F1405C779058",
            // },

        }
        return obj
    } else {
        if (isOnline) {
            let response = await PostRequest(`/api/auth/pwa/activate?code=${code}`, null, false);
            return response;
        } else {
            console.error(`Connection Broken! can't post the request to authDriverByCode endpoint`)
        }
    }
};
let GetKnock = async (data) => {
    if (isOnline) {
        let response = await GetRequest(`/api/kiosk/knock?kiosktag=${data.kiosktag}&kiosksecret=${data.kiosksecret}`, data);
        return response;
    } else {
        console.error(`Connection Broken! can't post the request to GetKnock endpoint`)
    }
};
let GetUsersFromAuthToken = async (authToken) => {
    if (isOnline) {
        let response = await GetRequest(`/api/mobile/GetUsersFromAuthToken`, false, false, authToken);
        return response;
    } else {
        console.error(`Connection Broken! can't post the request to GetUsersFromAuthToken endpoint`)
    }
}

let GetUserTokenFromAuthToken = async (userId) => {
    if (isOnline) {
        let response = await GetRequest(`/api/mobile/GetUserTokenFromAuthToken?userId=${userId}`, false, false, true);
        return response;
    } else {
        console.error(`Connection Broken! can't post the request to GetUserTokenFromAuthToken endpoint`)
    }
}

let GetTokenFromToken = async (gsid) => {
    if (isOnline) {
        let response = await GetRequest(`/api/mobile/GetTokenFromToken?GSID=${gsid}`, true, false, false);
        return response;
    } else {
        console.error(`Connection Broken! can't post the request to GetTokenFromToken endpoint`)
    }
}

let GetUserTokenFromKitchenCode = async (kitchenCode) => {
    if (isOnline) {
        let response = await AuthRequest(`/api/mobile/GetUserTokenFromKitchenCode?kitchenCode=${kitchenCode}`)
        return response;
    } else {
        console.error(`Connection Broken! can't post the request to GetUserTokenFromKitchenCode endpoint`)
    }
}

let AuthByPhone = async (phoneNumber) => {
    if (isOnline) {
        let response = await AuthRequest(`/api/mobile/AuthByPhone?phoneNumber=${phoneNumber}`);
        return response;
    } else {
        console.error(`Connection Broken! can't post the request to AuthByPhone endpoint`)
    }
}
let AuthByOTPCode = async (payload) => {
    if (isOnline) {
        // the end point will be change
        // let response = await AuthRequest(`/api/mobile/AuthByPhone?phoneNumber=${code}`);
        let response = await AuthRequest(`/api/mobile/AuthByPhoneCode?phoneNumber=${payload.phoneNumber}&phoneCode=${payload.otp}`);
        return response;
    } else {
        console.error(`Connection Broken! can't post the request to AuthByOTPCode endpoint`)
    }
}
let GetAppName = async (id) => {
    if (isOnline) {
        let response = await GetRequest(`/api/mobile/rides/GetCenterInfoByTag?deviceTagID=${id}`, true, false);
        return response;
    } else {
        console.error(`Connection Broken! can't post the request to authDriverByCode endpoint`)
    }
}
let GetCenterInfo = async (authToken) => {
    let baseUrl = AppSettings.serverUrl;

    if (isOnline) {
        // let response = await GetRequest(`/api/mobile/GetCenterInfo`, true, false);
        // return response;
        try {
            let headers = new Headers();
            headers.append('Authorization', authToken);
            let response = await fetch(`${baseUrl}/api/mobile/CenterInfo`, {
                method: "GET",
                headers: headers
            });
            if (response.status === 401) {
                window.location.href = '/token-expired'
            }
            let jsonRes = await response.json()
            return await jsonRes;
        } catch (error) {
            console.log(error);
        }

    } else {
        console.error(`Connection Broken! can't post the request to authDriverByCode endpoint`)
    }
}
let handleUnauthorized = async () => {
    localStorage.setItem("IsAuthorize", false)
    try {
        let authObject = JSON.parse(localStorage.getItem('USER_DATA'));
        if (authObject) {
            let drivers = AuthService.getAuthDataByName("DriverData");
            let userID = AuthService.getAuthDataByName("userID");
            let deviceTagID = AuthService.getAuthDataByName("deviceTagID");
            let data = {
                userid: userID ? userID : drivers[0].userID, gsid: authObject.gsid, deviceTagID: deviceTagID, deviceSecret: authObject.deviceSecret
            };
            let response = await GetDriverTokenByDevice(data);
            if (response && response.success) {
                AuthService.setUserData("tokenExpiration", response.data.tokenExpiration);
                AuthService.setUserData("tokenUID", response.data.tokenUID);
                localStorage.setItem("IsAuthorize", true)
                return;
            }
        }
    } catch (error) {
        console.log("User Unauthorized")
    }
}

// let handleRefreshToken = async () => {
//     try {
//         let authObject = JSON.parse(localStorage.getItem('USER_DATA'));
//         store.dispatch(updateIsLoadingRefreshToken(true))
//         if (authObject) {
//             if (authObject?.AuthToken) {
//                 let knockResponse = await GetKnock({
//                     kiosktag: authObject?.deviceTagID,
//                     kiosksecret: authObject?.deviceSecret
//                 })
//                 if (knockResponse && knockResponse.success) {
//                     AuthService.setUserData("AuthToken", knockResponse?.data?.AuthToken);
//                     let userTokenResponse = await GetUserTokenFromAuthToken(knockResponse?.data?.AuthToken);
//                     if (userTokenResponse && userTokenResponse.success) {
//                         AuthService.setUserData("tokenUID", userTokenResponse.data);
//                         store.dispatch(updateIsLoadingRefreshToken(false));
//                     } else {
//                         navigate("/token-expired");
//                         return;
//                     }
//                 } else {
//                     navigate("/token-expired");
//                     return;

//                 }
//             } else {
//                 navigate("/token-expired");
//                 return;
//             }

//         } else {
//             navigate("/token-expired");
//             return;
//         }
//     } catch (error) {
//         console.log("User Unauthorized")
//         navigate("/token-expired");
//     } finally {
//         store.dispatch(updateIsLoadingRefreshToken(false))
//         localStorage.setItem("alreadyVisited", false)
//     }
// }

let handleRefreshToken = async () => {
    try {
        let authObject = JSON.parse(localStorage.getItem('USER_DATA'));
        store.dispatch(updateIsLoadingRefreshToken(true))
        if (authObject) {
            if (authObject?.AuthToken) {
                let knockResponse = await GetKnock({
                    kiosktag: authObject?.deviceTagID,
                    kiosksecret: authObject?.deviceSecret
                })
                if (knockResponse && knockResponse.success) {
                    AuthService.setUserData("AuthToken", knockResponse?.data?.AuthToken);

                    // check userId
                    let userID = AuthService.getAuthDataByName("userID");
                    if (!userID) {
                        store.dispatch(updateIsLoadingRefreshToken(false))
                        navigate("/choose-user");
                        return;
                    } else {

                        let userTokenResponse = await GetUserTokenFromAuthToken(userID);
                        if (userTokenResponse && userTokenResponse.success) {
                            AuthService.setUserData("tokenUID", userTokenResponse.data);
                            if (authObject?.centerInfo?.gsid) { // means center available, so we can get token from token
                                let tokenResponse = await GetTokenFromToken(authObject?.gsid);
                                if (tokenResponse && tokenResponse.success) {
                                    AuthService.setUserData("tokenUID", tokenResponse.data);
                                }
                            }
                            store.dispatch(updateIsLoadingRefreshToken(false));
                        } else {
                            navigate("/token-expired");
                            return;
                        }
                    }

                } else {
                    navigate("/token-expired");
                    return;

                }
            } else {
                navigate("/token-expired");
                return;
            }

        } else {
            navigate("/token-expired");
            return;
        }
    } catch (error) {
        console.log("User Unauthorized")
        navigate("/token-expired");
    } finally {
        store.dispatch(updateIsLoadingRefreshToken(false))
        localStorage.setItem("alreadyVisited", false)
    }
}


let GetAuthToken = () => {
    // let hostName = window.location.hostname;
    // if (hostName !== constant?.driversDomain) {
    //     let userObj = AuthService.getAuthDataByName("userToken")
    //     if (userObj) {
    //         return userObj.tokenUID
    //     }
    // } else {
    //     let userObj = AuthService.getAuthDataByName("tokenUID")
    //     if (userObj) {
    //         return userObj
    //     }
    // }

    let tokenUID = AuthService.getAuthDataByName("tokenUID")
    if (tokenUID) {
        return tokenUID
    }
}
export default AuthService;

export { AuthByPhone, AuthByOTPCode, ActivateByCode, handleUnauthorized, GetAuthToken, GetAppName, GetCenterInfo, GetKnock, GetUserTokenFromAuthToken, handleRefreshToken, GetUsersFromAuthToken, GetTokenFromToken, GetUserTokenFromKitchenCode }



